<template><!-- 全網站共用footer -->
    <footer id="footer">
        <div class="footerList">
            <ul class="container">
                <li><a class="footer_link_accu0" href="https://www.tmnewa.com.tw/" target="_blank">官網首頁</a></li>
                <li><a class="footer_link_accu1" href="https://www.tmnewa.com.tw/product/intro/1" target="_blank">理賠服務</a></li>
                <li><a class="footer_link_accu2" href="https://www.tmnewa.com.tw/location" target="_blank">服務據點</a></li>
                <li><a class="footer_link_accu3" href="https://www.tmnewa.com.tw/customerservice/documentdownload/productterms" target="_blank">商品條款</a></li>
                <li><a class="footer_link_accu4" href="https://www.tmnewa.com.tw/customerprotectionstatement" target="_blank">聲明事項</a></li>
                <li><a class="footer_link_accu5" href="https://www.fsc.gov.tw/ch/index.jsp" target="_blank">金融監督管理委員會</a></li>
                <li><a class="footer_link_accu6" href="https://cpc.ey.gov.tw/" target="_blank">消費者保護</a></li>
                <li><a class="footer_link_accu7" href="https://law.lia-roc.org.tw/Law/Content?lsid=FL034012" target="_blank">保險業經營電子商務自律規範</a></li>
                <li><a class="footer_link_accu8" href="https://www.tmnewa.com.tw/insurance-fraud-prevention/" target="_blank">防詐杜絕風險專區</a></li>
            </ul>
        </div>
        <div class="copyright">
            <span>24小時客服、道路救援專線：0800-050-119</span><span>網路服務專線：0800-366-168 (服務時間：週一至週五上午8:30-下午5:30 ，國定假日除外)</span><span>地址：104 台灣台北市中山區南京東路三段130號8-13樓</span><span>建議瀏覽器：Chrome10、Safari16、Edge109以上版本</span>
            <div>新安東京海上遵循「保險業金融友善服務準則」之精神，建立友善的金融服務環境，提供多國語言貼心服務。<a href="https://easyaccess.tmnewa.com.tw/friendly.html" target="_blank">點此了解更多內容</a></div>
            <div>流程代碼： {{ clarityID }}</div>
        </div>

        <div class="footer_bottom">
            <div class="footer_bottom_inner">
                <div class="footer_head">
                    <div class="footer_logo"><img src="../assets/tokioMarineGroup.svg" alt="tokio marine group"></div>
                </div>
                <div class="footer_body">
                    <div class="footer_img"><a href="https://www.tokiomarinehd.com/company/information/ci.html" target="_blank"><img src="../assets/goodCompany.png" alt="To Be a Good Company"></a></div>
                    <small class="footer_copy">Copyright ©2023 新安東京海上產物保險股份有限公司 All rights reserved</small>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { ref, watch } from "vue";
import { defineProps } from "vue";

const props = defineProps({
    clarityIdProps: String
});

const clarityID = ref('');
watch(() => props.clarityIdProps, (value) => {
    clarityID.value = value;
});
</script>
<style lang="scss">

#footer {
    clear:both;
    text-align: center;
    color: $white;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    font-size:14px;
    background:$blue-700;
    .footerList {
        padding: 10px 0 5px;
        box-sizing: border-box;
        text-align: center;
        @media screen and (max-width: $pad) {
            padding:10px 0 0;
        }
        li{display:inline-block;border-right: 1px solid $white ;padding:0 10px;
            a{
                text-decoration: none;
            }
            &:last-of-type{border:0}
            @media screen and (max-width: $pad) {
                display:block;
                padding:10px 0;
                line-height:30px;
                width: 100%;
                border-right:0;
                border-bottom:1px solid $white;
                text-align:left;
                &:last-of-type{border-bottom:1px solid $white;}
            }
        }
    }
    .copyright{
        line-height:25px;
        padding:5px 0 10px;
        border-bottom:1px solid $white;
        span{
            border-right: 1px solid $white;
            padding: 0 10px;
            &:last-of-type{border:none;}
        }
        div a{
            text-decoration: underline;
        }
        @media screen and (max-width: $pad) {
            text-align:left;
            line-height:25px;
            padding:10px 0 20px;
            span{
                display:block;
                padding:0 20px;
                border: 0;
            }
            div{padding:0 20px;}
        }
        @media screen and (max-width: $mobile-large) {
            border:0;
        }
    }
    a {
        color: $white;
        font-size:14px;
    }
    .footer_bottom{
        background-image: linear-gradient(to right, #00b3fe, #039);
        img {
            max-width: 100%;
            height: auto;
            vertical-align: bottom;
        }
        .footer_bottom_inner{
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-image: url(../assets/bg-footer.png);
            background-position: right bottom;
            background-repeat:no-repeat;
            .footer_head{
                padding-left: 40px;
            }
            .footer_body{
                padding: 20px 133px 20px 0;
                text-align: right;
                .footer_copy{
                    margin-bottom: 0;
                    color: $white;
                    font-size: 0.65rem;
                    font-weight: 500;
                    padding: 3px 0;
                }
            }
        }
        @media screen and (max-width:$mobile-large) {
            position: relative;
            .footer_bottom_inner{
                justify-content: flex-end;
                padding: 7px 14px 20px;
                background-size: 72px;
                .footer_head{
                    position: absolute;
                    top: 6px;
                    left: 15px;
                    padding: 0;
                    .footer_logo>img{width:137px}
                }
                .footer_body{
                    padding:0;

                    .footer_img{
                        margin-bottom:2px;
                        img{width:140px}
                    }
                }
            }
        }
    }
}
</style>
